export const PROJECTS = {
    GET_PROJECTS: 'GET_PROJECTS',
    GET_PROJECTS_SUCCESS: 'GET_PROJECTS_SUCCESS',
    GET_PROJECTS_FAIL: 'GET_PROJECTS_FAIL',

    CREATE_PROJECT: 'CREATE_PROJECT',
    CREATE_PROJECT_SUCCESS: 'CREATE_PROJECT_SUCCESS',
    CREATE_PROJECT_FAIL: 'CREATE_PROJECT_FAIL',

    GET_PROJECT_TYPES: 'GET_PROJECT_TYPES',
    GET_PROJECT_TYPES_SUCCESS: 'GET_PROJECT_TYPES_SUCCESS',
    GET_PROJECT_TYPES_FAIL: 'GET_PROJECT_TYPES_FAIL',

    GET_PROJECT: 'GET_PROJECT',
    GET_PROJECT_SUCCESS: 'GET_PROJECT_SUCCESS',
    GET_PROJECT_FAIL: 'GET_PROJECT_FAIL',

    EDIT_PROJECT: 'EDIT_PROJECT',

    RESET_PROJECT: 'RESET_PROJECT',
    RESET_PROJECT_PARTICIPANTS: 'RESET_PROJECT_PARTICIPANTS',

    DOWNLOAD_PROJECT: 'DOWNLOAD_PROJECT',

    PROJECT_MEMBER_REMOVE: 'PROJECT_MEMBER_REMOVE',

    GET_PROJECTS_NOTIFICATIONS: 'GET_PROJECTS_NOTIFICATIONS',
    GET_PROJECTS_NOTIFICATIONS_SUCCESS: 'GET_PROJECTS_NOTIFICATIONS_SUCCESS',
    GET_PROJECTS_NOTIFICATIONS_FAIL: 'GET_PROJECTS_NOTIFICATIONS_FAIL',

    GET_PROJECT_CHATS: 'GET_PROJECT_CHATS',
    GET_PROJECT_CHATS_SUCCESS: 'GET_PROJECT_CHATS_SUCCESS',
    GET_PROJECT_CHATS_FAIL: 'GET_PROJECT_CHATS_FAIL',

    GET_PROJECT_CHATS_LIST: 'GET_PROJECT_CHATS_LIST',
    GET_PROJECT_CHATS_LIST_SUCCESS: 'GET_PROJECT_CHATS_LIST_SUCCESS',
    GET_PROJECT_CHATS_LIST_FAIL: 'GET_PROJECT_CHATS_LIST_FAIL',

    POST_PROJECT_CHATS_LIST_READ_ALL: 'GET_PROJECT_CHATS_LIST_READ_ALL',
    POST_PROJECT_CHATS_LIST_READ_GROUP: 'POST_PROJECT_CHATS_LIST_READ_GROUP',

    GET_PROJECT_CHATS_LIST_NEW: 'GET_PROJECT_CHATS_LIST_NEW',
    GET_PROJECT_CHATS_LIST_NEW_SUCCESS: 'GET_PROJECT_CHATS_LIST_NEW_SUCCESS',
    GET_PROJECT_CHATS_LIST_NEW_FAIL: 'GET_PROJECT_CHATS_LIST_NEW_FAIL',

    POST_PROJECT_CHATS_MESSAGE: 'POST_PROJECT_MEMBERS_LIST',

    GET_PROJECT_EMPLOYEES_FOR_ADDING: 'GET_PROJECT_EMPLOYEES_FOR_ADDING',
    GET_PROJECT_EMPLOYEES_FOR_ADDING_SUCCESS: 'GET_PROJECT_EMPLOYEES_FOR_ADDING_SUCCESS',
    GET_PROJECT_EMPLOYEES_FOR_ADDING_FAIL: 'GET_PROJECT_EMPLOYEES_FOR_ADDING_FAIL',

    GET_PROJECT_CLIENTS_FOR_ADDING: 'GET_PROJECT_CLIENTS_FOR_ADDING',
    GET_PROJECT_CLIENTS_FOR_ADDING_SUCCESS: 'GET_PROJECT_CLIENTS_FOR_ADDING_SUCCESS',
    GET_PROJECT_CLIENTS_FOR_ADDING_FAIL: 'GET_PROJECT_CLIENTS_FOR_ADDING_FAIL',

    GET_PROJECT_MEMBERS_LIST: 'GET_PROJECT_MEMBERS_LIST',
    GET_PROJECT_MEMBERS_LIST_SUCCESS: 'GET_PROJECT_MEMBERS_LIST_SUCCESS',
    GET_PROJECT_MEMBERS_LIST_FAIL: 'GET_PROJECT_MEMBERS_LIST_FAIL',

    GET_PROJECT_REVIEW_EMPLOYEE: 'GET_PROJECT_REVIEW_EMPLOYEE',
    GET_PROJECT_REVIEW_EMPLOYEE_SUCCESS: 'GET_PROJECT_REVIEW_EMPLOYEE_SUCCESS',
    GET_PROJECT_REVIEW_EMPLOYEE_FAIL: 'GET_PROJECT_REVIEW_EMPLOYEE_FAIL',

    PATCH_PROJECTS_NOTIFICATIONS: 'PATCH_PROJECTS_NOTIFICATIONS',

    POST_PROJECT_MEMBERS_LIST: 'POST_PROJECT_MEMBERS_LIST',

    PATCH_FINISH_PROJECT: 'PATCH_FINISH_PROJECT',
    PATCH_RESUME_OR_START_PROJECT: 'PATCH_RESUME_OR_START_PROJECT',
    PATCH_PAUSE_PROJECT: 'PATCH_PAUSE_PROJECT',

    ADD_PROJECT_TYPE: 'ADD_PROJECT_TYPE',

    BROADCAST_AUTH: 'BROADCAST_AUTH',

    UPDATE_COUNT_GENERAL: 'UPDATE_COUNT_GENERAL',
    UPDATE_COUNT_IN_PROJECT: 'UPDATE_COUNT_IN_PROJECT',

    GET_CHAT_MESSAGE: 'GET_CHAT_MESSAGE',


    GET_PROJECTS_AVATARS: "GET_PROJECTS_AVATARS",
    GET_PROJECTS_AVATARS_SUCCESS: "GET_PROJECTS_AVATARS_SUCCESS",
    GET_PROJECTS_AVATARS_FAIL: "GET_PROJECTS_AVATARS_FAIL",

    PROJECT_REMOVE: "PROJECT_REMOVE",
    PROJECT_REMOVE_SUCCESS: "PROJECT_REMOVE_SUCCESS",
    PROJECT_REMOVE_FAIL: "PROJECT_REMOVE_FAIL",


    PROJECT_SET_FILTER_STATUS: "PROJECT_SET_FILTER_STATUS",
};
